import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./registerServiceWorker";
import { Auth, Amplify } from "aws-amplify";
import { checkBrowser, isDevEnv } from "./utils";

const customer = import.meta.env.VITE_CUSTOMER ?? "mst";
const versionInfo = import.meta.env.VITE_OC_VERSION ?? null;

const userLoggedIn = async (): Promise<boolean> => {
  try {
    await Auth.currentAuthenticatedUser();
    return true;
  } catch {
    return false;
  }
};

if (versionInfo) {
  try {
    localStorage.setItem("oc_version", JSON.stringify(JSON.parse(versionInfo)));
  } catch {
    console.warn("Failed to populate the git version when building, version will be omitted.");
  }
}

if (!versionInfo && import.meta.env.MODE === "development") {
  document.title = `OC (Dev - ${customer})`;
}

const AmplifyAuthCheck = async (): Promise<void | JSX.Element> => {
  if (import.meta.env.MODE === "development") {
    const amplifyConfig: string = localStorage.getItem("amplify_config") || "";
    if (amplifyConfig.length > 0) {
      const config = JSON.parse(amplifyConfig);
      Amplify.configure(config);
    } else {
      fetch(`https://app-${customer}.skytrain.vmo.cloud/config`)
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          localStorage.setItem("amplify_config", JSON.stringify(res));
          Amplify.configure(res);
          // If using Firefox, block normal contextmenu from appearing as it breaks the timeline functionality.
          if (checkBrowser() === "Firefox") {
            window.addEventListener("contextmenu", (e: any) => e.preventDefault(), false);
          }
        });
    }
  } else {
    // Get Amplify config from local storage
    const amplifyConfig: string = localStorage.getItem("amplify_config") || "";
    if (amplifyConfig.length > 0) {
      const config = JSON.parse(amplifyConfig);
      Amplify.configure(config);
    } else {
      console.error("ERROR: Local Storage must contain amplify config to use application!");
      window.location.replace("/");
    }
    await userLoggedIn()
      .then((loggedIn: boolean) => {
        if (loggedIn === false) {
          window.location.replace("/");
        } else {
          Promise.resolve(true);
        }
      })
      .catch((error) => {
        console.error("Authentication check could not complete.");
      });
  }
};

AmplifyAuthCheck()
  .then(() => {
    const container = document.getElementById("root");
    if (container) {
      const root = createRoot(container);
      root.render(<App />);
    }
  })
  .catch((err) => {
    console.error(err);
  });
serviceWorker.unregister();
